var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _rect0, _rect1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 94,
    viewBox: "0 0 66 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5737,
    y: 7.58234,
    width: 37.7213,
    height: 75.4426,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8311,
    y: 8.83978,
    width: 35.2066,
    height: 62.8689,
    rx: 1,
    fill: "#266ACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8901,
    y: 7.32501,
    width: 15.0885,
    height: 5.02951,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42499 27.2152C1.42499 26.6629 1.8727 26.2152 2.42499 26.2152H38.1463C38.6986 26.2152 39.1463 26.6629 39.1463 27.2152V44.9803C39.1463 45.5326 38.6986 45.9803 38.1463 45.9803H28.5823C27.7565 45.9803 27.2866 46.9247 27.7847 47.5834L34.7255 56.7629C35.4037 57.6598 34.3142 58.8203 33.3763 58.2001L15.1477 46.1462C14.9841 46.038 14.7923 45.9803 14.5962 45.9803H2.42499C1.8727 45.9803 1.42499 45.5326 1.42499 44.9803V27.2152Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.1972,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2267,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2562,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2855,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3151,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3446,
    y: 33.7595,
    width: 3.77213,
    height: 5.02951,
    rx: 1.88607,
    fill: "#2EA76D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 53.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1633,
    y: 60.9032,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 48.1633 60.9032)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0916,
    y: 49.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 46.0916 49.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDelete);
export default __webpack_public_path__ + "static/media/phone-delete.dac3e4eb0201d4c9355fa61990c07bcf.svg";
export { ForwardRef as ReactComponent };